<template>
  <div class="yxtbiz-supplier-select" id="select">
    <yxt-select
      ref="select"
      v-model="selectOpition.checkWord"
      :placeholder="placeholder"
      :popper-append-to-body="false"
      :style="{ width: width }"
      :clearable="clearable"
      @clear="clearTreeSelect"
      :class="{ hideOption: !hideOption }"
      @focus="changeHideOption"
      :size="size"
    >
      <yxt-option
        :value="selectTree"
        class="setstyle"
        style="overflow: auto; height: 100%;background-color:#fff"
        disabled
      >
        <yxt-input
          :placeholder="$t('pc_biz_o2o_lbl_select_supplier_name')"
          v-model="filterSupplierTree"
          style="margin-top: 10px"
          @search="searchCatalog"
          searchable
        >
        </yxt-input>
        <yxt-tree
          :data="supplierTreeData"
          :props="defaultProps"
          ref="tree"
          check-strictly
          :node-key="filterKey"
          :expand-on-click-node="false"
          :filter-node-method="filterNode"
          @node-click="(data, node, item) => ClickTreeNode(data, node, item)"
        ></yxt-tree>
      </yxt-option>
    </yxt-select>
  </div>
</template>

<script>
import SelectPopover from '../../check-person-range/src/components/SelectPopover';
import { getModuleList } from './service';

export default {
  name: 'YxtbizSupplierSelect',
  props: {
    filterKey: {
      type: String,
      default: 'id'
    },
    placeholder: {
      type: String,
      default: ''
    },
    selectData: {
      type: Object,
      default() {
        return {};
      }
    },
    size: {
      type: String,
      default: 'medium'
    },
    width: {
      type: String,
      default: '300px'
    },
    optionWidth: {
      type: String,
      default: '648px'
    },
    optionHeight: {
      type: String,
      default: '500px'
    },
    optionMaxWidth: {
      type: String,
      default: '800px'
    },
    optionMaxHeight: {
      type: String,
      default: '500px'
    },
    optionMinWidth: {
      type: String,
      default: '300px'
    },
    optionMinHeight: {
      type: String,
      default: '400px'
    },
    selectOption: {
      type: Object,
      default() {
        return {
          supplierName: 'supplierName',
          supplierCreditCode: 'supplierCreditCode',
          id: 'id'
        };
      }
    },
    clearable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      hideOption: false,
      selectTree: '',
      treeLoading: true,
      selectOpition: {
        placeholder: this.$t('pc_biz_o2o_lbl_select_supplier_name'),
        checkWord: ''
      },
      filterSupplierTree: '',
      supplierTreeData: [],
      defaultProps: {
        label: 'supplierName',
        id: 'supplierCreditCode'
      },
      treeExpand: [''],
      defaultCheckedKeys: []
    };
  },
  components: {
    SelectPopover
  },
  created() {
    this.getSupplierTree();
  },
  mounted() {
    this.$nextTick(() => {
      this.filterSelectData();
      let dom = document
        .getElementById('select')
        .querySelector('.yxt-select-dropdown');
      dom.style.width = this.optionWidth;
      dom.style.height = this.optionHeight;
      dom.style.maxWidth = this.optionMaxWidth;
      dom.style.maxHeight = this.optionMaxHeight;
      dom.style.minWidth = this.optionMinWidth;
      dom.style.minHeight = this.optionMinHeight;
    });
  },
  watch: {
    filterSupplierTree(val) {
      this.$refs.tree.filter(val);
    },
    selectData() {
      this.$nextTick(() => {
        this.filterSelectData();
      });
    }
  },
  methods: {
    changeHideOption() {
      this.$nextTick(() => {
        this.hideOption = true;
      });
    },
    filterSelectData() {
      if (this.selectData[this.selectOption.supplierName]) {
        this.selectOpition.checkWord = this.selectData[
          this.selectOption.supplierName
        ];
      } else {
        this.selectOpition.checkWord = '';
      }
      if (this.selectData[this.selectOption[this.filterKey]]) {
        this.$refs.tree.setCurrentKey(
          this.selectData[this.selectOption[this.filterKey]]
        );
      } else {
        this.$refs.tree.setCurrentKey(null);
      }
    },
    searchCatalog(value) {
      this.$refs.tree.filter(value);
    },
    filterNode(value, data) {
      if (!value) return true;
      let name = data.supplierName.toLowerCase();
      let cValue = value.toLowerCase();
      return name.indexOf(cValue) !== -1;
    },
    clearTreeSelect() {
      this.selectOpition.checkWord = '';
      this.supplierTreeData = [...this.supplierTreeData];
      this.defaultCheckedKeys = [];
      this.$emit('getSelected', {});
    },
    ClickTreeNode(obj, node, _this) {
      this.hideOption = false;
      this.$refs.select.blur();
      this.selectOpition.checkWord = obj.supplierCreditCode
        ? obj.supplierName
        : '';
      this.$attrs.value = obj.supplierName;
      this.$emit('getSelected', obj);
    },
    getSupplierTree() {
      getModuleList(0, 5000, { keywords: '' })
        .then(res => {
          const { code, data } = res;
          if (code === '0') {
            this.supplierTreeData = data.datas;
            this.treeLoading = false;
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.yxtbiz-supplier-select {
  ::v-deep {
    .yxt-tree-node__content {
      height: 100%;
    }
    .is-current > .yxt-tree-node__content {
      .yxt-tree-node__label {
        color: var(--color-primary-6);
      }
    }
    .hideOption {
      .yxt-select-dropdown {
        display: none;
      }
    }
    .yxt-tree {
      margin-top: 10px;
    }
    .yxt-input input {
      padding-right: 10px;
    }
    .yxt-select-dropdown {
      height: 100%;
      .yxt-select-dropdown__layout {
        height: 100%;
      }
      .tree-scroll-wrap {
        width: 100% !important;
        height: calc(100% - 40px);
      }
      .yxt-scrollbar__wrap {
        overflow: auto;
      }
      .yxt-scrollbar {
        height: 100%;
        .yxt-select-dropdown__wrap {
          height: 100%;
          max-height: unset !important;
          overflow: hidden;
        }
      }
      .yxt-scrollbar__view {
        height: 100%;
      }
      .yxt-select-dropdown {
        overflow: hidden !important;
      }
      .yxt-scrollbar__bar {
        display: none;
      }
    }
  }
}
</style>
